module.exports = __webpack_public_path__ + "media/src/assets/menu_standards-4d78b0714f84d76f2d1bb2c46ae93cef.jpg";